var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDisabledMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94694 14.6667C11.6136 14.6667 14.6136 11.6667 14.6136 8.00004C14.6136 4.33337 11.6136 1.33337 7.94694 1.33337C4.28027 1.33337 1.28027 4.33337 1.28027 8.00004C1.28027 11.6667 4.28027 14.6667 7.94694 14.6667Z",
    stroke: "#B1B3B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28027 8H10.6136",
    stroke: "#B1B3B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisabledMinus);
export default __webpack_public_path__ + "static/media/iconDisabledMinus.857af3b2a77dbe45b415134dc3040c8a.svg";
export { ForwardRef as ReactComponent };